import { defineMessages } from "react-intl";

import { node as bikeErgometry } from "src/modules/ktx/forms/transplantation-screening/cardiology/bikeErgometry";
import { node as bloodPressure } from "src/modules/ktx/forms/transplantation-screening/cardiology/bloodPressure";
import { node as cardiologyOpinion } from "src/modules/ktx/forms/transplantation-screening/cardiology/cardiologyOpinion";
import { node as coronarography } from "src/modules/ktx/forms/transplantation-screening/cardiology/coronarography";
import { node as coronaryCt } from "src/modules/ktx/forms/transplantation-screening/cardiology/coronaryCt";
import { node as dse } from "src/modules/ktx/forms/transplantation-screening/cardiology/dse";
import { node as ekg } from "src/modules/ktx/forms/transplantation-screening/cardiology/ekg";
import { node as hearthMri } from "src/modules/ktx/forms/transplantation-screening/cardiology/hearthMri";
import { node as spect } from "src/modules/ktx/forms/transplantation-screening/cardiology/spect";
import { node as transtorachalisEcho } from "src/modules/ktx/forms/transplantation-screening/cardiology/transtorachalisEcho";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.cardiology",
		defaultMessage: "Kardiológia"
	}
});

export const node: ParentNode = {
	id: "ktx-cardiology",
	value: { type: "wizard", title: messages.title },

	children: [
		ekg,
		transtorachalisEcho,
		bikeErgometry,
		dse,
		spect,
		coronarography,
		hearthMri,
		cardiologyOpinion,
		coronaryCt,
		bloodPressure
	]
};
